const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/actions/casesActions.ts';
import { KISAPI as API } from '../middleware/kisapi';
import { IKISAPIAction, KisApiAction, kisapiActionTypes } from '../defs/actionTypes';
import { apiLoad1Case, apiLoadCases } from '@cistec/common_web/actions/kisapi/cases';

export const LOAD_CASES = kisapiActionTypes('LOAD_CASES');
export const LOAD_CASE_RECORD = kisapiActionTypes('LOAD_CASE_RECORD');

export interface ILoadCasesMeta {
    patnr: string;
    storeFullRecords?: boolean;
    showDlgWhenResultHasMoreRows: boolean;
}

export interface ILoadCasesAction extends IKISAPIAction {
    meta: ILoadCasesMeta;
}

export interface ILoadCaseRecordMeta {
    fallnr: string;
    withStdAndSpecRec: boolean;
    suppressErrorMsg: boolean;
}

/**
 * Loads the list of insurance cases of a particular patient.
 *
 * @param patnr (in): patient whose list of cases is to be loaded
 * @param storeFullRecords (in): true=do not attempt to be clever when storing the records
 * @param cacheType
 * @return: An action object.
 */
export function actionLoadCases(patnr: string, storeFullRecords?: boolean, cacheType?: RequestCache) {
    const meta: ILoadCasesMeta = {
        patnr,
        storeFullRecords,
        showDlgWhenResultHasMoreRows: true,
    };
    return {
        type: LOAD_CASES.combined,
        [API]: apiLoadCases(patnr, cacheType),
        meta,
    };
}

/**
 * Loads the record of a single case from KISAPI.
 */
export function actionLoadCaseRecord(fallnr: string, withStdAndSpecRec: boolean = false) {
    const meta: ILoadCaseRecordMeta = {
        fallnr,
        withStdAndSpecRec,
        suppressErrorMsg: false,
    };
    return {
        type: LOAD_CASE_RECORD.combined,
        [API]: apiLoad1Case(fallnr, withStdAndSpecRec),
        meta,
    };
}

export type ILoadCaseRecordAction = KisApiAction<typeof actionLoadCaseRecord>;
